import { useMemo } from 'react';
import { useGetCatalogQuery } from '../../../../redux/api/fymAPI';
import { CatalogItem } from '../../../../redux/api/fymAPI.types';

/** The newest first: the release day, else the day the song came into the Catalog. */
function songTime(item: CatalogItem): number {
  const value = Date.parse(item.releaseDate ?? item.claimedAt);
  return Number.isNaN(value) ? 0 : value;
}

/**
 * The songs of the active artist for the editor (design c6): the song of this page (the catalog row
 * that names the page), and the newest song (the Bio Link starters, design a3).
 */
export function useEditorSongs(accountId: number, smartLinkId: number, options: { skip?: boolean } = {}) {
  const { data, isLoading, error, refetch } = useGetCatalogQuery({ accountId }, { skip: options.skip === true });
  return useMemo(() => {
    const items = [...(data?.items ?? [])].sort((a, b) => songTime(b) - songTime(a));
    const pageSong =
      items.find((item) => item.smartLinkId === smartLinkId || (item.smartLinkIds ?? []).includes(smartLinkId)) ?? null;
    return { items, pageSong, newestSong: items[0] ?? null, isLoading, error, refetch };
  }, [data, error, isLoading, refetch, smartLinkId]);
}
